import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { MediaApiResponse } from '@mkp/shared/models';
import { exhaustMap } from 'rxjs';

export interface DocumentTokenDto {
  marketplaceClientSourceToken: string;
  _type: 'mediaApiToken';
}

export interface UploadMediaOptions {
  convertToPdf?: boolean;
  private?: boolean;
}

export interface UploadMediaParams extends UploadMediaOptions {
  file: Blob;
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class MediaApiResource {
  protected readonly http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT_PROVIDER);

  delete(id: string) {
    return this.http.delete(`${this.environment.api.media}/${id}`);
  }

  uploadMedia({
    file,
    token,
    convertToPdf = false,
    private: isPrivate = false,
  }: UploadMediaParams) {
    const formData = new FormData();
    formData.append('file', file);
    if (isPrivate) {
      formData.append('private', 'true');
    }
    if (convertToPdf) {
      formData.append('convertToPdf', 'true');
    }

    return this.http.post<MediaApiResponse>(this.environment.api.media, formData, {
      headers: new HttpHeaders({ 'x-source-jwt': token, maxRetry: 3 }),
    });
  }

  fetchTokenAndUploadMedia(file: Blob, options?: UploadMediaOptions) {
    return this.fetchToken().pipe(
      exhaustMap(({ marketplaceClientSourceToken: token }) =>
        this.uploadMedia({ file, token, ...options })
      )
    );
  }

  fetchToken() {
    return this.http.get<DocumentTokenDto>(`${this.environment.api.core}/token/media-api`, {
      headers: new HttpHeaders({ maxRetry: 3 }),
    });
  }
}
